const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  
  const isNotEmptyString = (input) => {
    return input.trim() !== "";
  };
  
  // const isValidInteger = (input) => {
  //   return !isNaN(input) && Number.isInteger(Number(input));
  // };
  
  const isStringLengthExceeded = (input, maxLength) => {
    return input.length > maxLength;
  };
  
  const isPasswordStrong = (password) => {
    // Password should contain at least one uppercase letter, one digit, and one special character
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])/;
    return passwordRegex.test(password);
  };
  
  export {
    isValidEmail,
    isNotEmptyString,
    isStringLengthExceeded,
    isPasswordStrong,
    // isValidInteger,
  };
  